var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2V9H2V2H12ZM2 0C0.896875 0 0 0.896875 0 2V9C0 10.1031 0.896875 11 2 11H5.66563L5.33125 12H3C2.44688 12 2 12.4469 2 13C2 13.5531 2.44688 14 3 14H11C11.5531 14 12 13.5531 12 13C12 12.4469 11.5531 12 11 12H8.66562L8.33125 11H12C13.1031 11 14 10.1031 14 9V2C14 0.896875 13.1031 0 12 0H2ZM16.5 0C15.6719 0 15 0.671875 15 1.5V12.5C15 13.3281 15.6719 14 16.5 14H18.5C19.3281 14 20 13.3281 20 12.5V1.5C20 0.671875 19.3281 0 18.5 0H16.5ZM17 2H18C18.275 2 18.5 2.225 18.5 2.5C18.5 2.775 18.275 3 18 3H17C16.725 3 16.5 2.775 16.5 2.5C16.5 2.225 16.725 2 17 2ZM16.5 4.5C16.5 4.225 16.725 4 17 4H18C18.275 4 18.5 4.225 18.5 4.5C18.5 4.775 18.275 5 18 5H17C16.725 5 16.5 4.775 16.5 4.5ZM17.5 9.5C17.7652 9.5 18.0196 9.60536 18.2071 9.79289C18.3946 9.98043 18.5 10.2348 18.5 10.5C18.5 10.7652 18.3946 11.0196 18.2071 11.2071C18.0196 11.3946 17.7652 11.5 17.5 11.5C17.2348 11.5 16.9804 11.3946 16.7929 11.2071C16.6054 11.0196 16.5 10.7652 16.5 10.5C16.5 10.2348 16.6054 9.98043 16.7929 9.79289C16.9804 9.60536 17.2348 9.5 17.5 9.5Z",
    fill: "#4D5874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineIcon);
export default __webpack_public_path__ + "static/media/machine_icon.5ed8ee3cfa26c63d5feeca1b34980916.svg";
export { ForwardRef as ReactComponent };